<div class="content-container">
  @if (!job_id) {
    <nz-spin [nzSpinning]="isCheckingPath" nzTip="Checking path for data...">
      @if (path_exists) {
        <h5>
          Output path found. Please assign to a project
        </h5>
        <form nz-form [formGroup]="newJobForm" class="login-form" class="form-container">
          <nz-spin [nzSpinning]="creatingJob">
            <nz-form-item style="flex-grow: 1">
              <nz-form-label for="output_path" nzRequired>Job Output Path</nz-form-label>
              <nz-form-control nzErrorTip="Please add a job output path">
                <input nz-input type="text" formControlName="output_path">
              </nz-form-control>
            </nz-form-item>
            <nz-form-item style="flex-grow: 1">
              <nz-form-label for="job_name" nzRequired>Job Name</nz-form-label>
              <nz-form-control nzErrorTip="Please add a job name">
                <input nz-input type="text" formControlName="job_name" placeholder="Add job name">
              </nz-form-control>
            </nz-form-item>
            <div style="display: flex;">
              <nz-form-item style="flex-grow: 1">
                <nz-form-label for="project" nzRequired>Project</nz-form-label>
                <nz-form-control nzErrorTip="Please select a Project">
                  <nz-select nzShowSearch [nzLoading]="isFetchingProjects"
                    [nzDisabled]="isFetchingProjects" nzPlaceHolder="Select a project"
                    formControlName="project" style="width: 100%;">
                    @for (project of projects; track project) {
                      <nz-option [nzValue]="project"
                      [nzLabel]="project.name"></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
              <button nz-button type="button" (click)="projectModalVisible = true">Create New
              Project</button>
            </div>
            <div nz-row [nzGutter]="12">
              <div nz-col [nzXs]="12">
                <nz-form-item>
                  <nz-form-label for="parentJob">Parent Job</nz-form-label>
                  <nz-form-control nzErrorTip="Please select a Parent Job">
                    <nz-select nzShowSearch [nzLoading]="isFetchingProjectJobs"
                      formControlName="parentJob" nzPlaceHolder="Select a parent job" nzAllowClear
                      style="width: 100%;">
                      @for (job of projectJobs; track job) {
                        <nz-option [nzValue]="job"
                        [nzLabel]="job.job_name"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="12">
                <nz-form-item>
                  <nz-form-label for="parentCpNum" [nzRequired]="newJobForm.value['parentJob']">Parent
                    CP
                  Number</nz-form-label>
                  <nz-form-control nzErrorTip="Please select a valid Parent CP Number">
                    <nz-input-number formControlName="parentCpNum" style="width: 100%;"
                      nzPlaceHolder="Select a parent CP number" [nzMin]="0"
                      [nzMax]="maxIterations">
                    </nz-input-number>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <nz-form-item>
              <nz-form-control
                nzExtra="In the case that NX2 > NX1, you may want to swap the 2 axis for visualization. Click on the checkbox if you'd like to do so.">
                <label nz-checkbox formControlName="x2_is_inline">Swap Dimensions?</label>
              </nz-form-control>
            </nz-form-item>
            <button nz-button nzType='primary' type="button" (click)="createNewJob()">Upload</button>
          </nz-spin>
        </form>
      } @else {
        <nz-result nzStatus="404" nzTitle="404" [nzSubTitle]="error_message">
          <div nz-result-extra>
            <p>Please check the path and try again.</p>
          </div>
        </nz-result>
      }
    </nz-spin>
  }
</div>

<nz-modal [(nzVisible)]="projectModalVisible" nzTitle="Create New Project" (nzOnCancel)="projectModalVisible = false"
  (nzOnOk)="createProject()" [nzOkLoading]="isCreatingProject"> <ng-container *nzModalContent>
  <div class="form-container">
    <nz-spin [nzSpinning]="isCreatingProject">

      <form nz-form [formGroup]="projectForm" class="login-form" (ngSubmit)="createProject()"
        class="form-container">
        <nz-form-item>
          <nz-form-label for="projectName" nzRequired>Project Name</nz-form-label>
          <nz-form-control nzErrorTip="Please input the project name!">
            <input nz-input formControlName="name" id="projectName" placeholder="Add a project name" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label for="description">Description</nz-form-label>
          <nz-form-control>
            <textarea nz-input formControlName="description" id="description"
            placeholder="Add a project description"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label for="field">Field</nz-form-label>
          <nz-form-control>
            <nz-select nzShowSearch [nzLoading]="isFetchingFields" [nzDisabled]="isFetchingFields"
              nzPlaceHolder="Select a field" formControlName="field" style="width: 100%;">
              @for (field of fields; track field) {
                <nz-option [nzValue]="field.id"
                [nzLabel]="field.name"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control
            nzExtra="Projects with Archive Enabled will automatically have their jobs archived after 7 days, unless specfically selected to be kept indefinitely.">
            <label nz-checkbox formControlName="archiveEnabled">Archive Enabled</label>
          </nz-form-control>
        </nz-form-item>
      </form>

    </nz-spin>

  </div>
</ng-container>
</nz-modal>